// extracted by mini-css-extract-plugin
export default {"app-container":"App_app-container__Vu1GH","loaded":"App_loaded__ERXI4"};